import React,{useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faXmark } from '@fortawesome/free-solid-svg-icons';
import ReactPlayer from 'react-player';
const Section_1 = () => {

    const [playing, setPlaying] = useState(false);
	const [playerKey, setPlayerKey] = useState(0);

    const isOpenVideoModal = () => {
        setPlaying(true);
    }
    const isCloseVideoModal = () => {
        setPlaying(false);
		setPlayerKey(prev => prev + 1);
    }
    
    return (
        <>
            <style>
                {
                    `#video_modal{
                        background-color:#0000005c;
                    }
                    #video_modal .cursor-pointer{
                        position:absolute;
                        background:#fff;
                        padding:12px 15px;
                        border-radius:50%;
                        margin:14px;
                        right:15px;
                    }
                    `
                }
            </style>
            <div className="container">
                <div className="hero-area-inner">
                    <div className="area-shape-2"></div>
                    <div className="section-content">
                        <div className="section-title-wrapper">
                            <div className="title-wrapper">
                                <h1 className="section-title has_fade_anim text-gray-700 fs-4x ls-1 text-grad">
                                    Conversations that drive
                                    fulfillment
                                </h1>
                            </div>
                        </div>
                        <div className="text-wrapper">
                            <p className="text has_fade_anim fs-2 text-gray-900 text-grad-2" data-delay="0.30">
                                Talk about Sales, Customer Support, Technical Support, Hiring, Room Services,
                                Consultative Services – business works on fulfillment of a sale or service.
                                <br />
                                <br />
                                TruVoice.ai drives fulfillment of business outcomes through rich, contextual,
                                intelligent and engaging 2-way conversations.
                            </p>
                        </div>
                        <div className="btn-wrapper has_fade_anim" data-delay="0.45">
                            <button className="wc-btn wc-btn-primary btn-text-flip p-5" data-bs-toggle="modal"
                                data-bs-target="#book_demo_modal"> 
                                <span data-text="Request Demo" className='fs-4'>Request Demo</span>
                            </button>
                        </div>
                    </div>
                    <div className="hero-thumb">
                        <div className="">
                            <img 
                                alt="tv-logo" 
                                className="w-100 rounded" 
                                src={('/saiFile/landing/tv-video-2.jpg')}
                            />
                            <div 
                                className='ripple-wrapper cursor-pointer' 
                                data-bs-toggle="modal" 
                                data-bs-target="#video_modal"
                                onClick={isOpenVideoModal}
                            >
                                <FontAwesomeIcon 
                                    icon={faCirclePlay} 
                                    className='fs-5x position-absolute top-50 start-50 translate-middle'
                                    style={{color: '#f61616', background:'#fff', borderRadius: '50%'}}
                                />
                                <span className="ripple-circle"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade modal-lg" id="video_modal" data-bs-backdrop="false" data-bs-keyboard="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div
                                className="cursor-pointer text-end me-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={isCloseVideoModal}
                            >
                                <FontAwesomeIcon icon={faXmark} className='fs-1 text-grey-700' />
                            </div>
                            <ReactPlayer
                                url="https://www.youtube.com/embed/5p8dv1ljUVg?rel=0&modestbranding=1&controls=0&autohide=1&playsinline=0&showinfo=0&autoplay=1"
                                controls={true}
                                playing={playing}
                                loop={true}
                                key={playerKey}
                                width="100%"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export {Section_1}